import React from "react";
import {FormControl, InputLabel, MenuItem} from "@material-ui/core";

export default function CustomSelect(props) {
    const {open, handleClose, handleOpen, value, handleChange, items} = props;
    return (
        <FormControl>
            <InputLabel id="demo-controlled-open-select-label">Age</InputLabel>
            <CustomSelect
                open={open}
                onClose={handleClose}
                onOpen={handleOpen}
                value={value}
                onChange={handleChange}
            >
                {items && items.map(item => {
                    return <MenuItem key={item.value} value={item.value}>{item.text}</MenuItem>
                })}
            </CustomSelect>
        </FormControl>)
}
